import React, { Fragment, useState, useEffect, useRef } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router";
import swal from "sweetalert";
import "./School.css";

const API_URL = process.env.REACT_APP_API_URL;

const OpenModal = ({ data, isOpen, closeHandler }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={closeHandler} className="school-setup-modal" centered>
        <ModalHeader className="school-setup-modal-header">
          Course List File Uploaded Successfully!!!
        </ModalHeader>
        <ModalBody>
          <div style={{ padding: "6px" }}>
            {data &&
              <div className="school-setup-modal-error">
                <h4>Course List File Upload Error</h4>
                {data?.error?.map((item, index) =>
                  <div key={index} className="school-setup-modal-error-item">
                    {item}
                  </div>
                )}
              </div>}

          </div>
        </ModalBody>
        <ModalFooter>
          <button className="school-setup-modal-close" onClick={closeHandler}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </Fragment>);

};

const SchoolSetup = () => {
  let history = useHistory();
  const uploadCourseRef = useRef();
  const [uploadCourseFile, setUploadCourseFile] = useState();
  const [dataAfterFileUpload, setDataAfterFileUpload] = useState();
  const [loadingForCsvDownload, setLoadingForCsvDownload] = useState(false);

  const [openModalAfterUpload, setOpenModalAfterUpload] = useState(false);








  // const user = useSelector((state) => state.UserReducer?.userObj);
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );




  //   const [enableState, setEnableState] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [dataPrint] = useState();





  const [loadingForUCSetup, setLoadingForUCSetup] = useState(false);





  // const getSchoolsList = (value) => {
  //   setSchoolNameLoading(true);
  //   let obj = {
  //     q: value,
  //   };
  //   GetStudentService.getSchoolsList(obj)
  //     .then((data) => {
  //       setSchoolNameList(data?.data?.objects);

  //       setSchoolNameLoading(false);
  //       setShowSchoolNameContainer(true);
  //     })
  //     .catch((error) => {
  //       setSchoolNameLoading(false);
  //     });
  // };

  // const handleSchoolName = () => {
  //   clearTimeout(timeoutRef.current);
  //   setSchoolName(schoolNameRef.current.value);
  //   if (!schoolNameRef.current.value) {
  //     setShowSchoolNameContainer(false);
  //     setSchoolNameList([]);
  //   } else {
  //     timeoutRef.current = setTimeout(() => {
  //       getSchoolsList(schoolNameRef.current.value);
  //     }, 1000);
  //   }
  // };

  // const handleSelectedSchoolName = (item) => {
  //   setSchoolNameList([item]);
  //   setShowSchoolNameContainer(false);
  //   setSchoolName(item?.name);
  //   // setOpenModifySchool(true);
  //   // setEnableState(true);
  //   setModifyData(item);
  //   setSchoolId(item?.id);
  //   // setSchoolName('');
  // };


  const downLoadCsvTemplate = () => {
    setLoadingForCsvDownload(true);
    let template = [];
    template.push([
      '"Datasource"',
      '"UC A (History/Social Science)"',
      '"UC B (English)"',
      '"UC C (Mathematics)"',
      '"UC D (Laboratory Science)"',
      '"UC E (Foreign Language)"',
      '"UC E (Foreign Language)"',
      '"UC F (Visual & Performing Arts)"',
      '"UC G (College Prep Elective)"']
    );
    let arr = template;
    let ret = [];
    for (let i = 0, len = arr.length; i < len; i++) {
      let line = [];
      for (let key in arr[i]) {
        if (arr[i].hasOwnProperty(key)) {
          line.push(arr[i][key]);
        }
      }
      ret.push(line.join(","));
      ret.push('"Course_History_Template"');
    }
    let result_csv = ret.join("\n");
    let saving = document.createElement("a");
    saving.href = "data:attachment/csv," + encodeURIComponent(result_csv);
    saving.download = "csv_course_history_template.csv";
    document.body.appendChild(saving);
    saving.click();
    setLoadingForCsvDownload(false);
  };

  const uploadCourseHandler = () => {
    let file = uploadCourseRef.current.files[0];
    setUploadCourseFile(file);
  };

  const uploadFileHandler = () => {
    let formData = new FormData();
    formData.append("csvfilename", undefined);
    formData.append("csv_file", uploadCourseFile);
    fetch(`${API_URL}/api/v1/course/upload-file`, {
      method: "POST",
      headers: {
        "x-authorization": `Bearer ${localStorage.getItem("token")}`
      },
      body: formData
    })
      .then((response) => response.json())
      .then((data) => {
        setDataAfterFileUpload(data);
      })
      .catch(() => { });
  };

  useEffect(() => {
    if (uploadCourseFile) {
      uploadFileHandler();
    }
  }, [uploadCourseFile]);

  const uploadCourse = () => {
    let obj = {
      school: user?.school_id,
      upload: dataAfterFileUpload?.message
    };
    GetStudentService.uploadAfter(obj)
      .then((data) => {
        setDataAfterFileUpload(data.data);
        uploadCourseRef.current.value = "";
        setUploadCourseFile(null);
      })
      .catch(() => { });
  };

  function handleOptionChange(event) {
    setSelectedOption(event.target.value);
  }

  function handleDropdownChange(event) {
    setSelectedValue(event.target.value);
  }

  // const getDistrictsList = (value) => {
  //   setDistrictNameLoading(true);
  //   let obj = {
  //     q: value,
  //   };
  //   GetStudentService.getDistrictsList(obj)
  //     .then((data) => {
  //       setDistrictNameList(data?.data?.objects);
  //       setDistrictNameLoading(false);
  //       setShowDistrictNameContainer(true);
  //     })
  //     .catch((error) => {
  //       setDistrictNameLoading(false);
  //     });
  // };

  const getDataSwal = () => {
    setLoadingForUCSetup(true);
    GetStudentService.getDataSwal(user?.school_id)
      .then((data) => {
        swal({
          title: "Successfully",
          text: data?.data?.message,
          icon: "success",
          buttons: {
            OK: true
          },
          closeOnClickOutside: true
        });
        setLoadingForUCSetup(false);
      })
      .catch((_error) => {
        setLoadingForUCSetup(false);
        swal({
          title: "Oops!!",
          text: "This school is not eligible for setup process.",
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: true
        });
      });
  };
  // const handleDistrictName = () => {
  //   clearTimeout(timeoutRef.current);
  //   setDistrictName(districtNameRef.current.value);
  //   if (!districtNameRef.current.value) {
  //     setShowDistrictNameContainer(false);
  //     setDistrictNameList([]);
  //   } else {
  //     timeoutRef.current = setTimeout(() => {
  //       getDistrictsList(districtNameRef.current.value);
  //     }, 1000);
  //   }
  // };

  // const handleSelectedDistrictName = (item) => {
  //   setDistrictID(item?.id);
  //   setDistrictNameList([item]);
  //   setShowDistrictNameContainer(false);
  //   setDistrictName(item.name);
  //   // getDistrictPage(item?.id);
  // };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="school-setup-page">
            <div className="school-setup-header">
              <div>
                <h1 className="school-setup-title">School Setup</h1>
                <p className="school-setup-subtitle">
                  Configure district state and UC/CSU course setup options
                </p>
              </div>
              {selectedOption === "yes" &&
                <button
                  onClick={downLoadCsvTemplate}
                  className="school-setup-btn ghost"
                  type="button">

                  Download CSV Template File For UC/CSU
                  {loadingForCsvDownload &&
                    <span>
                      <Loader
                        type="TailSpin"
                        color="#1395f2"
                        height={18}
                        width={18} />

                    </span>}

                </button>}

            </div>

            <div className="school-setup-card">
              <div className="school-setup-field">
                <label className="school-setup-label">District</label>
                <div className="school-setup-district-input">
                  {user?.district_name}
                </div>

              </div>

              <div className="school-setup-field">
                <label className="school-setup-label">Select State</label>
                <select
                  className="school-setup-select"
                  value={selectedValue}
                  onChange={handleDropdownChange}>

                  <option value="">Select State</option>
                  <option value="california">California</option>
                  <option value="non-california" disabled>
                    Non-California
                  </option>
                </select>
              </div>

              {selectedValue === "california" &&
                <div className="school-setup-field">
                  <label className="school-setup-label">
                    Course List File Upload
                  </label>
                  <div className="school-setup-radio-group">
                    <label className="school-setup-radio">
                      <input
                        type="radio"
                        value="yes"
                        checked={selectedOption === "yes"}
                        onChange={handleOptionChange} />
                      Yes
                    </label>
                    <label className="school-setup-radio">
                      <input
                        type="radio"
                        value="no"
                        checked={selectedOption === "no"}
                        onChange={handleOptionChange} />
                      No
                    </label>
                  </div>
                </div>}


              {selectedOption === "yes" &&
                <div>
                  <div className="school-setup-upload-row">
                    <input
                      type="file"
                      ref={uploadCourseRef}
                      onChange={uploadCourseHandler}
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />

                    <button
                      onClick={uploadCourse}
                      className="school-setup-btn primary"
                      type="button">

                      Upload
                    </button>
                  </div>
                  <div className="school-setup-actions">
                    {dataPrint === "CSU/UC A to G Setup Enable" ?
                      <button
                        onClick={() => getDataSwal()}
                        className="school-setup-btn secondary"
                        type="button">

                        UC/CSU A To G Setup
                        {loadingForUCSetup &&
                          <span>
                            <Loader
                              type="TailSpin"
                              color="white"
                              height={15}
                              width={15} />

                          </span>}

                      </button> :

                      ""}

                  </div>
                </div>}


              {selectedOption === "no" &&
                <div className="school-setup-actions">
                  <button
                    onClick={() => getDataSwal()}
                    className="school-setup-btn secondary"
                    type="button">

                    UC/CSU A To G Setup
                    {loadingForUCSetup &&
                      <span>
                        <Loader
                          type="TailSpin"
                          color="white"
                          height={15}
                          width={15} />

                      </span>}

                  </button>
                </div>}

            </div>
          </div>
          {openModalAfterUpload &&
            <OpenModal
              data={dataAfterFileUpload}
              isOpen={openModalAfterUpload}
              closeHandler={() => {
                setOpenModalAfterUpload(false);
                history.push("/school_it/school_setup");
              }} />}


        </div>
      </div>
    </Fragment>);

};
export default SchoolSetup;